export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Old password:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New password:"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm Password:"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["\"New Password\" and \"Confirm Password\" do not match."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change password"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["String from 4 to 63 characters. \nLatin characters, numbers and symbols are allowed"])}
}